import React from 'react';
import DataTableHeader from './DataTableHeader';
import DataTableRow from './DataTableRow';

const DataTable = (props) => {
    let headers = [];
    const rows = [];

    if (props.columns) {
        headers = props.columns.map((c, i) => (
            <DataTableHeader
                key={c.header + i}
                header={c.header}
                hasDivider={i !== props.columns.length - 1}
                cellWidth={c.width}
            />
        ));

        if (props.data) {
            for (const rowDataIndex in props.data) {
                const rowData = props.data[rowDataIndex];
                rows.push(<DataTableRow key={rowDataIndex} columns={props.columns} data={rowData} />);
            }
        }
    }

    return (
        <React.Fragment>
            <table className="data-table">
                <thead className="data-table-header">
                    <tr className="header-row">
                        <th className="divider"></th>
                        {headers}
                        <th className="divider"></th>
                    </tr>
                </thead>
                <tbody className="data-table-body">
                    {rows.length > 0 ? (
                        rows
                    ) : (
                        <tr>
                            <td></td>
                            <td
                                className="empty-table"
                                colSpan={
                                    props.columns && props.columns.length > 1 ? (props.columns.length - 1) * 3 + 1 : 1
                                }>
                                {props.loading
                                    ? 'Loading...'
                                    : props.noDataText
                                    ? props.noDataText
                                    : 'No data to display.'}
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </React.Fragment>
    );
};

export default DataTable;
